export default (storeRoute) => ({
  loading: false,

  async share() {
    if (this.loading) {
      return;
    }

    this.loading = true;

    try {
      const response = await fetch(storeRoute, {
        method: "POST",
        headers: {
          "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to share attachment");
      }

      const message = await response.json();

      this.$dispatch("message-created", message.data);

      this.$el.closest("[popover]")?.hidePopover();
    } catch (error) {
      console.error("Error sharing attachment:", error);
    } finally {
      this.loading = false;
    }
  },
});
